import { useState } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import moment from "moment";


import ChartSelects from "components/Charts/Selectors/Stats";
import reportsAPI from 'services/api/reports';

// @mui material components
import { Card, Divider, Grid } from "@mui/material";
import Swal from "sweetalert2";
import fileDownload from "js-file-download";
import ParkingValidation from "assets/json/ParkingValidation.json";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import SoftButton from "components/SoftComponents/SoftButton";
import theme from "assets/theme";
import { useAuth0 } from "@auth0/auth0-react";
import ReportingColumnChart from "./chart/ReportingColumnChart";
import ReportingDoughnutChart from "./chart/ReportingDoughnutChart";
import SoftTypography from "components/SoftComponents/SoftTypography";
function getGroupSize(start, end) {
  var gap = end - start;
  return (gap) / 40;
}

function NodeReporting({ device, user, deviceLayout, title = "", height = "22svh" }) {
  const [startTime, setStartTime] = useState(moment().tz(ParkingValidation['timezone']).subtract(2, "week").startOf('day'));
  const [endTime, setEndTime] = useState(moment().tz(ParkingValidation['timezone']));
  const [reportStartTime, setReportStartTime] = useState(moment().tz(ParkingValidation['timezone']).startOf('day').unix());

  const groupSize = endTime.unix(); //getGroupSize(startTime.unix(), endTime.unix());

  reportsAPI.loadToken(useAuth0());

  async function downloadPDF() {
    Swal.showLoading();

    const options = {
      responseType: 'blob',
      onDownloadProgress: function (progressEvent) {
        const percentComplete = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
        if (percentComplete == 100) {
          Swal.close();
        }
      }
    }

    var body = {
      devices: [
        {
          uuid: device.uuid,
          name: device.name,
          serial_number: device.serial_number,
          position: device.position,
          site_id: device?.site_id ? device.site_id : device.stop.site_id
        }
      ]
    };

    var reportEndTime = moment(reportStartTime * 1000).tz(ParkingValidation['timezone']).add(1, 'day').startOf('day').unix();
    reportsAPI.getCameraObjectsReport([device.uuid], reportStartTime, reportEndTime, options, body).then(function (data) {
      var formatted_start_time = moment(reportStartTime * 1000).tz(ParkingValidation['timezone']).format('DDMM');

      fileDownload(data, `${device.name}_${formatted_start_time}.pdf`);
    });
  };

  const generateReport = (
    <>
      <SoftBox display="flex" justifyContent="center" alignItems="center" py={{ xxs: 1, sm: 1 }} pr={{ xxs: 1, x3l: 1 }}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker format="DD/MM/YYYY" value={moment(reportStartTime * 1000).tz(ParkingValidation['timezone'])} minDate={moment("YYYY-MM-DD", "2026-03-01").tz(ParkingValidation['timezone'])} maxDate={moment().tz(ParkingValidation['timezone'])} onChange={(new_value) => { setReportStartTime(new_value.tz(ParkingValidation['timezone']).unix()) }} />
        </LocalizationProvider>
        <SoftBox display={theme.breakpoints.up("x3l") ? 'none' : 'flex'}>
          <SoftButton variant="gradient" color="info" onClick={() => { downloadPDF(); }}>Generate Report</SoftButton>
        </SoftBox>
      </SoftBox>
      <SoftBox display={theme.breakpoints.up("x3l") ? 'flex' : 'none'}>
        <SoftButton variant="gradient" color="info" onClick={() => { downloadPDF(); }}>Generate Report</SoftButton>
      </SoftBox>
    </>
  );

  return (

    <Card sx={{ height: '100%', width: '100%', background: '#f9f9f9', overflowY: 'auto' }}>
      <SoftBox height="100%" display="flex" flexDirection="column" justifyContent="flex-start" p={3}>
        <SoftBox height="100%" display="flex" flexDirection="column" justifyContent="space-evenly" maxHeight="fit-content">
          <SoftBox>
            <SoftTypography variant="h4" fontWeight="bold">Daily Infringement Reporting</SoftTypography>
            <SoftTypography variant="body3">This details the infringements for a 24-hour period, detailing the type of parking zone, length of offence, and vehicle type.</SoftTypography>
          </SoftBox>
          <SoftBox>
            <SoftBox display='flex' alignItems={{ xxs: "center" }} justifyContent="center">
              {generateReport}
            </SoftBox>
          </SoftBox>
        </SoftBox>
        <SoftBox>
          <SoftBox my={1}>
            <Divider />
          </SoftBox>
          <SoftBox>
            <SoftTypography py={1} variant="h4" fontWeight="bold">Historical Infringement Statistics</SoftTypography>
          </SoftBox>
          <ChartSelects {...{ startTime, setStartTime, endTime, setEndTime }} />
          <Grid container spacing={2} mb={1}>
            <Grid item xxs={12}>
              <ReportingColumnChart title={'Infringement History'} {...{ device, startTime, setStartTime, endTime, setEndTime, groupSize, height }} />
            </Grid>
            <Grid item xxs={12}>
              <ReportingDoughnutChart title={'Daily Infringement Average (Per Zone)'} {...{ device, startTime, setStartTime, endTime, setEndTime, groupSize, height }} />
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </Card>
  );

}

// Typechecking props for the NodeReporting
NodeReporting.propTypes = {
  device: PropTypes.object,
  user: PropTypes.object,
  deviceLayout: PropTypes.string,
  title: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default NodeReporting;

